/* eslint-disable no-shadow */
// eslint-disable-next-line import/no-cycle
import { WhatsAppTemplateState } from '@src/types';

export enum ButtonType {
  URL = 'URL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  QUICK_REPLY = 'QUICK_REPLY',
  FLOW = 'FLOW',
}

export enum RedirectionType {
  AGENT = 'AGENT',
  DEPARTMENT = 'DEPARTMENT',
  NONE = 'NONE',
}

export enum TemplateType {
  HEADER = 'HEADER',
  FOOTER = 'FOOTER',
  BUTTONS = 'BUTTONS',
  CALL_PERMISSION = 'CALL_PERMISSION_REQUEST',
  REQUEST_CONTACT_INFO = 'REQUEST_CONTACT_INFO',
}

export enum FormatType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
  VIDEO = 'VIDEO',
}

export enum WhatsAppTemplateType {
  START_RETAKE = 'START_RETAKE',
  BROADCAST = 'BROADCAST',
}

export enum QuickReplyMessageType {
  TEXT = 'TEXT',
  AUDIO = 'AUDIO',
  PDF = 'PDF',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

export enum UriType {
  STATIC = 'STATIC',
  DYNAMIC = 'DYNAMIC',
}

export enum WhatsAppTemplateMode {
  CREATE = 'create',
  EDIT = 'edit',
}

export type ButtonComponent = Partial<
  UrlButton & PhoneButton & QuickReplyButton & FlowButton
>;

export type WhatsappTemplateComponent = {
  type: TemplateType;
  format?: FormatType;
  image?: File;
  document?: File;
  video?: File;
  url?: string;
  mime?: string;
  text?: string;
  buttons?: ButtonComponent[];
};

export type UrlButton = {
  text: string;
  type: ButtonType;
  uriType: UriType;
  url: string;
  id?: string;
};

export type PhoneButton = {
  text: string;
  type: ButtonType;
  phoneNumber: string;
};

export type QuickReplyButton = {
  text: string;
  type: ButtonType;
  quickReplyButtonSettings: QuickReplyButtonSettings;
};

export type FlowButton = {
  text: string;
  type: ButtonType;
  flowButtonSettings: {
    flowId: string;
    screenId: string;
  };
};

export type QuickReplyMessage = {
  type: QuickReplyMessageType;
  text?: string;
  url?: string;
  file?: File | null | string;
};

export type QuickReplyButtonSettings = {
  redirection: {
    target: RedirectionType;
    targetId: number | null;
  };
  action: {
    type?: 'SEND_MESSAGE' | 'NONE';
    messages: QuickReplyMessage[];
  };
};

export type WhatsAppTemplateFormValues = {
  mode: WhatsAppTemplateMode;
  name: string;
  messageWithPlaceHolders: string;
  type: string;
  status: WhatsAppTemplateState;
  language: string;
  category: string;
  components: {
    HEADER: WhatsappTemplateComponent;
    FOOTER: WhatsappTemplateComponent;
    BUTTONS?: WhatsappTemplateComponent;
    CALL_PERMISSION_REQUEST?: WhatsappTemplateComponent;
    REQUEST_CONTACT_INFO?: WhatsappTemplateComponent;
  };
  // Partial<Record<TemplateType, WhatsappTemplateComponent>>;
  headerComponent: boolean;
  footerComponent: boolean;
  buttonsComponent: boolean;
  formError?: string;
};

export type FlowButtonConfig = {
  flowId: string;
  screenId: string;
  buttonName: string;
};
